import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-12">
      <div className="mb-6">
        <span className="inline-block text-xs font-medium tracking-widest text-accent-600 uppercase mb-1">
          Categories
        </span>
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
          赛事分类快捷入口
        </h2>
        <p className="mt-1.5 text-sm text-foreground-600">
          覆盖足球、篮球、电竞、网球等主流项目，点击即可进入对应分类赛事列表。
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 flex flex-col items-center text-center hover:border-accent-300 transition-colors"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} w-6 h-6 flex items-center justify-center text-xl`} />
            </span>
            <span className="mt-3 font-heading text-sm md:text-base font-semibold text-foreground-950">
              {cat.shortName}
            </span>
            <span className="mt-1 text-xs text-foreground-500">{cat.count} 场赛事</span>
          </Link>
        ))}
      </div>
    </section>
  );
}